import { ReplenishmentTemplateItemImportPage } from "@/features/replenishment-template-item/pages/ReplenishmentTemplateItemImportPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/replenishment-template/$id/import")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["replenishment_template.edit"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	return <ReplenishmentTemplateItemImportPage replenishmentTemplateID={id} />;
}
